/**
 * 前の画面にもどるボタン（船員アプリ共通）。
 *
 * 画面を開いたあと戻れずに詰まる、という声があったため各画面のヘッダーに置く。
 * 履歴があればブラウザ履歴で戻り、無ければホーム（かんたん画面を選んでいる端末は
 * かんたん画面）へ戻す。
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isSimpleMode } from '../utils/simpleMode';

export const BackButton: React.FC<{ size?: number; style?: React.CSSProperties }> = ({ size = 40, style }) => {
  const nav = useNavigate();
  const goBack = () => {
    if (window.history.length > 1) window.history.back();
    else nav(isSimpleMode() ? '/simple' : '/home');
  };
  return (
    <button onClick={goBack} aria-label="前の画面にもどる"
      style={{
        width: size, height: size, flexShrink: 0, border: '1.5px solid #e2e8f0', background: '#fff',
        borderRadius: 12, cursor: 'pointer', fontSize: Math.round(size / 2), color: '#334155',
        display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, ...style,
      }}>
      ‹
    </button>
  );
};
